import { LockPlusOutlineIcon } from './LockPlusOutlineIcon';

/**
 * author: Colton Wiscombe
 * id A4B343ED-8C07-4BD5-9F01-B360F971D23C
 * name lock-plus-outline
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-plus-outline.svg
 * tags
 * - Lock 
 */
export const EncryptionPlusOutlineIcon = LockPlusOutlineIcon;
export default EncryptionPlusOutlineIcon